module.exports = __webpack_public_path__ + "static/media/Refrigerator.187ad7ae.svg";